import classnames from 'classnames'
import { ROLES } from '../index'

export default function Text({ value, role }) {
  return (
    <p className={classnames('wrapper', { sent: role === ROLES.sender })}>
      {value}

      <style jsx>{`
        .wrapper {
          color: var(--primary-text-color);
          max-width: 70%;
          width: max-content;
          margin: 0.6rem auto 0 0;
          padding: 1rem 1rem 0.9rem 1.7rem;
          background: var(--secondary-input-bg);
          overflow: hidden;
          border-radius: 1rem;
          text-align: start;
          font-weight: 500;
          font-size: 1.8rem;

          &.sent {
            margin: 0.6rem 0 0 auto;
            padding: 0.9rem 1.7rem 1rem 1rem;
            background: #d7e8fd;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            display: block;
            font-size: 1.4rem;
            line-height: 1.9rem;
          }
        }
      `}</style>
    </p>
  )
}
